// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Gen = require("../Control.Monad.Gen/index.js");
var Data_Argonaut_Core = require("../Data.Argonaut.Core/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Decode_Combinators = require("../Data.Argonaut.Decode.Combinators/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Argonaut_Encode_Combinators = require("../Data.Argonaut.Encode.Combinators/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Lens_Prism = require("../Data.Lens.Prism/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_NonEmpty = require("../Data.NonEmpty/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Test_QuickCheck_Arbitrary = require("../Test.QuickCheck.Arbitrary/index.js");
var Test_QuickCheck_Gen = require("../Test.QuickCheck.Gen/index.js");
var $$Number = (function () {
    function $$Number(value0) {
        this.value0 = value0;
    };
    $$Number.create = function (value0) {
        return new $$Number(value0);
    };
    return $$Number;
})();
var $$String = (function () {
    function $$String(value0) {
        this.value0 = value0;
    };
    $$String.create = function (value0) {
        return new $$String(value0);
    };
    return $$String;
})();
var Bool = (function () {
    function Bool(value0) {
        this.value0 = value0;
    };
    Bool.create = function (value0) {
        return new Bool(value0);
    };
    return Bool;
})();
var NArray = (function () {
    function NArray(value0) {
        this.value0 = value0;
    };
    NArray.create = function (value0) {
        return new NArray(value0);
    };
    return NArray;
})();
var Pair = (function () {
    function Pair(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Pair.create = function (value0) {
        return function (value1) {
            return new Pair(value0, value1);
        };
    };
    return Pair;
})();
var Null = (function () {
    function Null() {

    };
    Null.value = new Null();
    return Null;
})();
var $$Function = (function () {
    function $$Function(value0) {
        this.value0 = value0;
    };
    $$Function.create = function (value0) {
        return new $$Function(value0);
    };
    return $$Function;
})();
var toNumber = function (v) {
    if (v instanceof $$Number) {
        return v.value0;
    };
    return 0.0;
};
var toArray = function (v) {
    if (v instanceof NArray) {
        return v.value0;
    };
    return [  ];
};
var showRuntimeValue = new Data_Show.Show(function (v) {
    if (v instanceof Null) {
        return "";
    };
    if (v instanceof Bool) {
        if (v.value0) {
            return "True";
        };
        return "False";
    };
    if (v instanceof $$Number) {
        return Data_Show.show(Data_Show.showNumber)(v.value0);
    };
    if (v instanceof $$String) {
        return Data_Show.show(Data_Show.showString)(v.value0);
    };
    if (v instanceof NArray) {
        return "[" + (Data_String_Common.joinWith(", ")(Data_Functor.map(Data_Functor.functorArray)(Data_Show.show(showRuntimeValue))(v.value0)) + "]");
    };
    if (v instanceof $$Function) {
        return "Function";
    };
    if (v instanceof Pair) {
        return "(" + (Data_Show.show(showRuntimeValue)(v.value0) + (", " + (Data_Show.show(showRuntimeValue)(v.value1) + ")")));
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Runtime (line 122, column 10 - line 129, column 63): " + [ v.constructor.name ]);
});
var toString = function (v) {
    if (v instanceof $$String) {
        return v.value0;
    };
    return Data_Show.show(showRuntimeValue)(v);
};
var genericRuntimeValue = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof $$Number) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof $$String) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof Bool) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
    };
    if (x instanceof NArray) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
    };
    if (x instanceof Pair) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))))));
    };
    if (x instanceof Null) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
    };
    if (x instanceof $$Function) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))));
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Runtime (line 88, column 1 - line 88, column 62): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new $$Number(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new $$String(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return new Bool(x.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
        return new NArray(x.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
        return new Pair(x.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value1);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
        return Null.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
        return new $$Function(x.value0.value0.value0.value0.value0.value0);
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Runtime (line 88, column 1 - line 88, column 62): " + [ x.constructor.name ]);
});
var eqRuntimeValue = new Data_Eq.Eq(function (v) {
    return function (v1) {
        if (v instanceof $$Number && v1 instanceof $$Number) {
            return v.value0 === v1.value0;
        };
        if (v instanceof $$String && v1 instanceof $$String) {
            return v.value0 === v1.value0;
        };
        if (v instanceof Bool && v1 instanceof Bool) {
            return v.value0 === v1.value0;
        };
        if (v instanceof NArray && v1 instanceof NArray) {
            return Data_Eq.eq(Data_Eq.eqArray(eqRuntimeValue))(v.value0)(v1.value0);
        };
        if (v instanceof Pair && v1 instanceof Pair) {
            return Data_Eq.eq(eqRuntimeValue)(v.value0)(v1.value0) && Data_Eq.eq(eqRuntimeValue)(v.value1)(v1.value1);
        };
        if (v instanceof Null && v1 instanceof Null) {
            return true;
        };
        return false;
    };
});
var ordRuntimeValue = new Data_Ord.Ord(function () {
    return eqRuntimeValue;
}, function (v) {
    return function (v1) {
        if (v instanceof $$Number && v1 instanceof $$Number) {
            return Data_Ord.compare(Data_Ord.ordNumber)(v.value0)(v1.value0);
        };
        if (v instanceof $$String && v1 instanceof $$String) {
            return Data_Ord.compare(Data_Ord.ordString)(v.value0)(v1.value0);
        };
        if (v instanceof Bool && v1 instanceof Bool) {
            return Data_Ord.compare(Data_Ord.ordBoolean)(v.value0)(v1.value0);
        };
        if (v instanceof NArray && v1 instanceof NArray) {
            return Data_Ord.compare(Data_Ord.ordArray(ordRuntimeValue))(v.value0)(v1.value0);
        };
        if (v instanceof Pair && v1 instanceof Pair) {
            return Data_Ord.compare(Data_Tuple.ordTuple(ordRuntimeValue)(ordRuntimeValue))(new Data_Tuple.Tuple(v.value0, v.value1))(new Data_Tuple.Tuple(v1.value0, v1.value1));
        };
        return Data_Ordering.EQ.value;
    };
});
var toBoolean = function (value) {
    if (Data_Eq.eq(eqRuntimeValue)(value)(new Bool(true))) {
        return true;
    };
    if (Data_Boolean.otherwise) {
        return false;
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Runtime (line 47, column 1 - line 47, column 37): " + [ value.constructor.name ]);
};
var encodeJsonRuntimeValue = new Data_Argonaut_Encode_Class.EncodeJson(function (v) {
    if (v instanceof $$Number) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("type")("number"))(Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJNumber)("value")(v.value0))(Data_Argonaut_Core.jsonEmptyObject));
    };
    if (v instanceof $$String) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("type")("string"))(Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("value")(v.value0))(Data_Argonaut_Core.jsonEmptyObject));
    };
    if (v instanceof Bool) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("type")("boolean"))(Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJBoolean)("value")(v.value0))(Data_Argonaut_Core.jsonEmptyObject));
    };
    if (v instanceof NArray) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("type")("array"))(Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonArray(encodeJsonRuntimeValue))("value")(v.value0))(Data_Argonaut_Core.jsonEmptyObject));
    };
    if (v instanceof Pair) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("type")("pair"))(Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonTuple(encodeJsonRuntimeValue)(encodeJsonRuntimeValue))("value")(new Data_Tuple.Tuple(v.value0, v.value1)))(Data_Argonaut_Core.jsonEmptyObject));
    };
    return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("type")("null"))(Data_Argonaut_Core.jsonEmptyObject);
});
var decodeJsonRuntimeValue = new Data_Argonaut_Decode_Class.DecodeJson(function (json) {
    return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeForeignObject(Data_Argonaut_Decode_Class.decodeJsonJson))(json))(function (obj) {
        return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonString)(obj)("type"))(function (type$prime) {
            if (type$prime === "number") {
                return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonNumber)(obj)("value"))(function (value) {
                    return Control_Applicative.pure(Data_Either.applicativeEither)(new $$Number(value));
                });
            };
            if (type$prime === "string") {
                return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonString)(obj)("value"))(function (value) {
                    return Control_Applicative.pure(Data_Either.applicativeEither)(new $$String(value));
                });
            };
            if (type$prime === "boolean") {
                return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonBoolean)(obj)("value"))(function (value) {
                    return Control_Applicative.pure(Data_Either.applicativeEither)(new Bool(value));
                });
            };
            if (type$prime === "array") {
                return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeArray(decodeJsonRuntimeValue))(obj)("value"))(function (value) {
                    return Control_Applicative.pure(Data_Either.applicativeEither)(new NArray(value));
                });
            };
            if (type$prime === "pair") {
                return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonTuple(decodeJsonRuntimeValue)(decodeJsonRuntimeValue))(obj)("value"))(function (v) {
                    return Control_Applicative.pure(Data_Either.applicativeEither)(new Pair(v.value0, v.value1));
                });
            };
            if (type$prime === "null") {
                return Control_Applicative.pure(Data_Either.applicativeEither)(Null.value);
            };
            return Data_Either.Left.create("Cannot parse runtime value of type " + type$prime);
        });
    });
});
var binaryFunction = function (f) {
    return $$Function.create(function ($132) {
        return $$Function.create(f($132));
    });
};
var ternaryFunction = function (f) {
    return $$Function.create(function ($133) {
        return binaryFunction(f($133));
    });
};
var arbitraryRuntimeValue = new Test_QuickCheck_Arbitrary.Arbitrary(Control_Monad_Gen.oneOf(Test_QuickCheck_Gen.monadGenGen)(Data_NonEmpty.foldable1NonEmpty(Data_Foldable.foldableArray))(new Data_NonEmpty.NonEmpty(Control_Applicative.pure(Test_QuickCheck_Gen.applicativeGen)(Null.value), [ Data_Functor.map(Test_QuickCheck_Gen.functorGen)($$Number.create)(Test_QuickCheck_Arbitrary.arbitrary(Test_QuickCheck_Arbitrary.arbNumber)), Data_Functor.map(Test_QuickCheck_Gen.functorGen)($$String.create)(Test_QuickCheck_Arbitrary.arbitrary(Test_QuickCheck_Arbitrary.arbString)), Data_Functor.map(Test_QuickCheck_Gen.functorGen)(Bool.create)(Test_QuickCheck_Arbitrary.arbitrary(Test_QuickCheck_Arbitrary.arbBoolean)) ])));
var coarbitraryRuntimeValue = new Test_QuickCheck_Arbitrary.Coarbitrary(function (v) {
    if (v instanceof $$Number) {
        return Test_QuickCheck_Arbitrary.coarbitrary(Test_QuickCheck_Arbitrary.coarbNumber)(v.value0);
    };
    if (v instanceof $$String) {
        return Test_QuickCheck_Arbitrary.coarbitrary(Test_QuickCheck_Arbitrary.coarbString)(v.value0);
    };
    if (v instanceof Bool) {
        return Test_QuickCheck_Arbitrary.coarbitrary(Test_QuickCheck_Arbitrary.coarbBoolean)(v.value0);
    };
    if (v instanceof NArray) {
        return Test_QuickCheck_Arbitrary.coarbitrary(Test_QuickCheck_Arbitrary.coarbArray(coarbitraryRuntimeValue))(v.value0);
    };
    if (v instanceof Null) {
        return Test_QuickCheck_Arbitrary.coarbitrary(Test_QuickCheck_Arbitrary.coarbUnit)(Data_Unit.unit);
    };
    if (v instanceof $$Function) {
        return Test_QuickCheck_Arbitrary.coarbitrary(Test_QuickCheck_Arbitrary.coarbFunction(arbitraryRuntimeValue)(coarbitraryRuntimeValue))(v.value0);
    };
    if (v instanceof Pair) {
        return Test_QuickCheck_Arbitrary.coarbitrary(Test_QuickCheck_Arbitrary.coarbTuple(coarbitraryRuntimeValue)(coarbitraryRuntimeValue))(new Data_Tuple.Tuple(v.value0, v.value1));
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Runtime (line 131, column 1 - line 138, column 59): " + [ v.constructor.name ]);
});
var _String = function (dictChoice) {
    return Data_Lens_Prism["prism'"]($$String.create)(function (v) {
        if (v instanceof $$String) {
            return new Data_Maybe.Just(v.value0);
        };
        return Data_Maybe.Nothing.value;
    })(dictChoice);
};
var _Number = function (dictChoice) {
    return Data_Lens_Prism["prism'"]($$Number.create)(function (v) {
        if (v instanceof $$Number) {
            return new Data_Maybe.Just(v.value0);
        };
        return Data_Maybe.Nothing.value;
    })(dictChoice);
};
var _Function = function (dictChoice) {
    return Data_Lens_Prism["prism'"]($$Function.create)(function (v) {
        if (v instanceof $$Function) {
            return new Data_Maybe.Just(v.value0);
        };
        return Data_Maybe.Nothing.value;
    })(dictChoice);
};
module.exports = {
    "Number": $$Number,
    "String": $$String,
    Bool: Bool,
    NArray: NArray,
    Pair: Pair,
    Null: Null,
    "Function": $$Function,
    binaryFunction: binaryFunction,
    ternaryFunction: ternaryFunction,
    toBoolean: toBoolean,
    toNumber: toNumber,
    toString: toString,
    toArray: toArray,
    "_Number": _Number,
    "_String": _String,
    "_Function": _Function,
    genericRuntimeValue: genericRuntimeValue,
    encodeJsonRuntimeValue: encodeJsonRuntimeValue,
    decodeJsonRuntimeValue: decodeJsonRuntimeValue,
    showRuntimeValue: showRuntimeValue,
    coarbitraryRuntimeValue: coarbitraryRuntimeValue,
    arbitraryRuntimeValue: arbitraryRuntimeValue,
    eqRuntimeValue: eqRuntimeValue,
    ordRuntimeValue: ordRuntimeValue
};
